'use client';

import { cn } from '@/libs';

type SpinnerProps = {
  size?: number;
  className?: string;
};

export const Spinner = ({ size = 20, className }: SpinnerProps) => {
  return (
    <div
      className={cn(
        'animate-rotate rounded-full border-2 border-foreground/25 border-t-foreground',
        className,
      )}
      style={{ width: size, height: size }}
    />
  );
};
